import '../scss/app.scss';

import ripplet from 'ripplet.js';
import initDropdown from './utils/dropdown'
import Modal, { ModalHTMLElement } from './components/modal';
import { initYoutubeIframe } from './components/youtube-iframe';
import initInformationsBanner from './components/informations-banner';
import initDrawer from './utils/drawer-menu';
import initGalleryBlock from './modules/gallery-block';
import initReadMore from './modules/read-more-block';
import initPageWithAsideNav from './pages/page-with-aside-nav';
import initHeaderHome from './modules/header-home';
import initArchivePress from './pages/archive-press';
import initArchiveEvents from './pages/archive-events';
import initArchiveMediatheque from './pages/archive-mediatheque';
import initMaillageServicesProBlock from './modules/maillage-services-pro';
import initTabBarHandler from './utils/tab-bar-handler';
import initLastPostsEventsBlock from './modules/last-posts-events-block';
import initRegister from './pages/register';
import initSlimSelect from './utils/slim-select';
import initDisableIfNoValue from './components/disable-if-no-value';
import initArchiveDigitalPlatform from './pages/archive-digital-platform';
import initAgendaBlock from './modules/agenda-block';
import initCarouselBlock from './modules/carousel-block';
import initAudioBlock from './modules/audio-block';
import initDieteticiansBlock from './modules/dieticians-block';
import initTableauReglementationBlock from './modules/tableau-reglementation-block';
import initFrmForms from './modules/frm-forms';
import initSearchPage from './pages/search-page';
import initArchiveRelaunchPlan from './pages/archive-relaunch-plan';
import initSingleSolutionHeader from './pages/single-solution';
import initArchiveSolution from './pages/archive-solution';
import initLogosRequestForm from './components/logos-request-form';
import initCardCarousel from './components/carousel-card';
import initHeaderInnovation from './utils/header-innovation';
import initCheck from './utils/number-check';
import toggleBlockVisibility from './pages/depot-projet';
import { initPlfeForm } from './modules/plfe-form';
import initTeledeclarationTab from "./pages/teledeclaration"

// Fix de la valeur de "100vh" pour les appareils iOS + Fix de la valeur de "100vw"
function appHeight() {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);

// Initialisation ripplet sur les boutons
document.querySelectorAll<HTMLElement>('.ripplet').forEach($el => $el.addEventListener('click', ripplet));

// Initialisation bouton de recherche mobile
const $mobileSearchToggler = document.querySelector<HTMLElement>('.js-mobile-search-toggler');
const $searchForm = document.querySelector<HTMLElement>('.js-search-form');
if ($mobileSearchToggler && $searchForm) {
    $mobileSearchToggler.addEventListener('click', () => {
        $searchForm.classList.toggle('open');
    });

    // Ajout du focus à l'ouverture
    $searchForm.addEventListener('transitionend', () => {
        if (window.innerWidth < 1040) {
            if ($searchForm.classList.contains('open')) {
                $searchForm.querySelector('input')?.focus();
            } else {
                $searchForm.querySelector('input')?.blur();
            }
        }
    });
}

// Initialisation modales
document.querySelectorAll<ModalHTMLElement>('[data-modal-id]').forEach($modal => new Modal($modal));

// Gestion des boutons pour afficher/masquer les mot de passe
document.querySelectorAll<HTMLElement>('.js-show-hide-password').forEach($button => {
    const $passwordField = $button.closest<HTMLElement>('.form-field')?.querySelector('input[type="password"]');

    if ($passwordField) {
        $button.addEventListener('click', () => {
            const fieldType = $passwordField.getAttribute('type');
            $passwordField.setAttribute('type', fieldType === 'password' ? 'text' : 'password');
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    function toggleCheckboxes(selectAllCheckbox: HTMLInputElement, checkboxes: NodeListOf<HTMLInputElement>) {
        checkboxes.forEach((checkbox) => {
            checkbox.checked = selectAllCheckbox.checked;
            toggleCheckboxClass(checkbox);
        });

        toggleCheckboxClass(selectAllCheckbox);
    }

    function toggleCheckboxClass(checkbox: HTMLInputElement) {
        const parentElement = checkbox.closest('.left');
        const choiceElement = checkbox.closest('.choice');
        if (parentElement) {
            if (checkbox.checked) {
                parentElement.classList.add('checked');
            } else {
                parentElement.classList.remove('checked');
            }
        }

        if (choiceElement) {
            if (checkbox.checked) {
                choiceElement.classList.add('checked');
            } else {
                choiceElement.classList.remove('checked');
            }
        }
    }

    function addSelectAllHandler(selectAllCheckboxSelector: string, checkboxesSelector: string) {
        const selectAllCheckbox = document.querySelector<HTMLInputElement>(selectAllCheckboxSelector);
        const checkboxes = document.querySelectorAll<HTMLInputElement>(checkboxesSelector);

        if (selectAllCheckbox) {
            selectAllCheckbox.addEventListener('change', () => {
                toggleCheckboxes(selectAllCheckbox, checkboxes);
            });

            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', () => {
                    const anyChecked = Array.from(checkboxes).some(cb => cb.checked);
                    selectAllCheckbox.checked = anyChecked;
                    toggleCheckboxClass(selectAllCheckbox);
                });
            });

            // Initialisation de l'état de selectAllCheckbox en fonction de l'état des cases individuelles
            const anyChecked = Array.from(checkboxes).some(cb => cb.checked);
            selectAllCheckbox.checked = anyChecked;
            toggleCheckboxClass(selectAllCheckbox);

            // Initialiser l'affichage des classes pour chaque case à cocher
            checkboxes.forEach((checkbox) => {
                toggleCheckboxClass(checkbox);
            });
        }
    }

    function addCheckboxHandler(checkboxSelector: string) {
        const checkboxes = document.querySelectorAll<HTMLInputElement>(checkboxSelector);
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
                toggleCheckboxClass(checkbox);
            });
        });
    }

    function addSelectAllPageHandler(selectAllCheckboxSelector: string, checkboxesSelector: string) {
        const selectAllCheckbox = document.querySelector<HTMLInputElement>(selectAllCheckboxSelector);
        const checkboxes = document.querySelectorAll<HTMLInputElement>(checkboxesSelector);

        if (selectAllCheckbox) {
            selectAllCheckbox.addEventListener('change', () => {
                toggleCheckboxes(selectAllCheckbox, checkboxes);
            });
            
            toggleCheckboxClass(selectAllCheckbox);
                checkboxes.forEach((checkbox) => {
                toggleCheckboxClass(checkbox);
            });
        }
    }

    addSelectAllPageHandler(
        'input[name="user_notifications_preferences_form[select_all_type]"]',
        'input[name^="user_notifications_preferences_form["]:not(input[name="user_notifications_preferences_form[select_all_mediatheque_fruits_vegetables]"], input[name^="user_notifications_preferences_form[mediatheque-fruit-vegetable]"])'
    );

    addSelectAllHandler(
        'input[name="user_notifications_preferences_form[select_all_digital_platform]"]',
        'input[name^="user_notifications_preferences_form[digital-platform-category]"]'
    );

    addSelectAllHandler(
        'input[name="user_notifications_preferences_form[select_all_mediatheque_sector]"]',
        'input[name^="user_notifications_preferences_form[mediatheque-sector]"]'
    );

    addSelectAllHandler(
        'input[name="user_notifications_preferences_form[select_all_post_category]"]',
        'input[name^="user_notifications_preferences_form[category]"]'
    );

    addSelectAllHandler(
        'input[name="user_notifications_preferences_form[select_all_mediatheque_fruits_vegetables]"]',
        'input[name^="user_notifications_preferences_form[mediatheque-fruit-vegetable]"]'
    );

    addCheckboxHandler('input[name="user_notifications_preferences_form[relaunch-plan]"]');
    addCheckboxHandler('input[name="user_notifications_preferences_form[projet]"]');
    addCheckboxHandler('input[name="user_notifications_preferences_form[event]"]');
    addCheckboxHandler('input[name="user_notifications_preferences_form[press]"]');
    addCheckboxHandler('input[name="user_notifications_preferences_form[solution]"]');
    addCheckboxHandler('input[name^="user_notifications_preferences_form["]');
});

// Popin dans la page 'Dashboard'
document.addEventListener('DOMContentLoaded', () => {
    const step1 = document.querySelector('.step-1') as HTMLElement;
    const step2 = document.querySelector('.step-2') as HTMLElement;
    const step3 = document.querySelector('.step-3') as HTMLElement;
    const nextStep1Button = document.querySelector('.form-next-btn-1') as HTMLButtonElement;
    const prevStep2Button = document.querySelector('.form-prev-btn-2') as HTMLButtonElement;
    const nextStep2Button = document.querySelector('.form-next-btn-2') as HTMLButtonElement;

    if (!step1 || !step2 || !nextStep1Button || !prevStep2Button || !nextStep2Button) {
        console.error('One or more elements not found');
        return;
    }

    function showStep(step: HTMLElement) {
        step.classList.remove('hidden');
        step.classList.add('visible');
    }

    function hideStep(step: HTMLElement) {
        step.classList.remove('visible');
        step.classList.add('hidden');
    }

    nextStep1Button.addEventListener('click', () => {
        hideStep(step1);
        showStep(step2);
    });

    prevStep2Button.addEventListener('click', () => {
        hideStep(step2);
        showStep(step1);
    });

    nextStep2Button.addEventListener('click', () => {
        hideStep(step2);
        showStep(step3);
    });
});

// Popin dans la page 'Préférence'
document.addEventListener('DOMContentLoaded', () => {
    const serviceList = document.querySelector('.services-list') as HTMLElement;
    const flList = document.querySelector('.fruit-list') as HTMLElement;
    const serviceButton = document.querySelector('.btn-service') as HTMLButtonElement;
    const flButton = document.querySelector('.btn-fl') as HTMLButtonElement;

    if (!serviceButton || !serviceList || !flButton || !flList) {
        console.error('One or more elements not found');
        return;
    }

    function showList(step: HTMLElement) {
        step.classList.remove('hidden');
        step.classList.add('visible');
    }

    function hideList(step: HTMLElement) {
        step.classList.remove('visible');
        step.classList.add('hidden');
    }

    serviceButton.addEventListener('click', () => {
        showList(serviceList);
        hideList(flList);
    });

    flButton.addEventListener('click', () => {
        showList(flList);
        hideList(serviceList);
    });
});

// Popin 'Notification'
// document.addEventListener('DOMContentLoaded', () => {
//     const container = document.querySelector('.container') as HTMLElement;
//     const fixed = document.querySelector('.modal--notification') as HTMLElement;

//     const updateFixedPosition = () => {
//         if (container && fixed) {
//             const containerRect = container.getBoundingClientRect();
//             fixed.style.left = `${containerRect.left + 275}px`;
//         }
//     };

//     // Initial position update
//     updateFixedPosition();

//     // Update position on window resize
//     window.addEventListener('resize', updateFixedPosition);
// });

// Fonction pour défiler vers le haut du bouton 'scroll-top'
function scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

document.addEventListener('DOMContentLoaded', () => {
    const scrollButton = document.querySelector('.scroll-top') as HTMLElement;
    if (scrollButton) {
        scrollButton.addEventListener('click', scrollToTop);
    }
});

// Animation notification
document.addEventListener('DOMContentLoaded', () => {
    const itemNotifs = document.querySelectorAll('.notif') as NodeListOf<HTMLElement>;
    const numberElement = document.querySelector('.notif-number') as HTMLElement;

    function updateCounter() {
        let count = 0;

        itemNotifs.forEach(itemNotif => {
            const postItem = itemNotif.querySelector('.post-item') as HTMLElement;
            if (postItem && !postItem.classList.contains('viewed')) {
                count++;
            }
        });

        if (numberElement) {
            numberElement.textContent = count > 0 ? count.toString() : '';
        }
    }

    itemNotifs.forEach(itemNotif => {
        const postItem = itemNotif.querySelector('.post-item') as HTMLElement;

        itemNotif.addEventListener('click', () => {
            if (postItem) {
                postItem.classList.add('viewed');
            }
            updateCounter();
        });
    });

    updateCounter();
});

document.addEventListener("DOMContentLoaded", () => {
    const blocs = document.querySelectorAll('.content-list .bloc-content');
  
    blocs.forEach((bloc, index) => {
      if (index % 2 === 0) {
        bloc.classList.add('odd');
      } else {
        bloc.classList.add('even');
      }
    });
});
  
document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll<HTMLElement>('.filter-input-inner-wrapper, .archive-relaunch-plan-filters');
    window.addEventListener('load', () => {
        elements.forEach((element) => {
            element.style.visibility = 'visible';
        });
    });
});

// Form concours-talents : popin cession image
document.addEventListener("DOMContentLoaded", function () {
    const linkSession = document.getElementById("link-cession");
    const boutonCession = document.getElementById("bouton-cession");

    if (linkSession && boutonCession) {
        linkSession.addEventListener("click", function (event) {
            event.preventDefault();
            boutonCession.click();
        });
    }
});

// Form concours-talents : spinner & overlay in frm_dropzone
document.addEventListener("DOMContentLoaded", () => {
    const dropzoneWrapper = document.querySelector(".concours-talents .frm_dropzone") as HTMLElement | null;
    if (!dropzoneWrapper) return;

    const observer = new MutationObserver(() => {
        const previews = dropzoneWrapper.querySelectorAll(".dz-preview");

        previews.forEach((preview) => {
            const previewElement = preview as HTMLElement;

            if (!previewElement.querySelector(".upload-spinner")) {
                const spinner = document.createElement("span");
                spinner.classList.add("upload-spinner");
                previewElement.appendChild(spinner);
            }

            if (!previewElement.querySelector(".dz-overlay")) {
                const overlay = document.createElement("div");
                overlay.classList.add("dz-overlay");
                previewElement.appendChild(overlay);
            }

            const spinner = previewElement.querySelector(".upload-spinner") as HTMLElement;
            const overlay = previewElement.querySelector(".dz-overlay") as HTMLElement;

            if (previewElement.classList.contains("dz-complete")) {
                spinner.style.display = "none";
                overlay.style.display = "none";
            } else {
                spinner.style.display = "block";
                overlay.style.display = "block";
            }
        });
    });

    observer.observe(dropzoneWrapper, { childList: true, subtree: true });
});

// Utils
initYoutubeIframe();
initDropdown();
initDrawer();
initTabBarHandler();
initInformationsBanner();
initSlimSelect();
initDisableIfNoValue();
initLogosRequestForm();
initHeaderInnovation();

// Pages
initPageWithAsideNav();
initArchivePress();
initArchiveEvents();
initArchiveMediatheque();
initArchiveDigitalPlatform();
initArchiveRelaunchPlan();
initRegister();
initSearchPage();
initSingleSolutionHeader();
initArchiveSolution();

// Modules
initHeaderHome();
initGalleryBlock();
initReadMore();
initMaillageServicesProBlock();
initLastPostsEventsBlock();
initAgendaBlock();
initCarouselBlock();
initAudioBlock();
initDieteticiansBlock();
initFrmForms();
initTableauReglementationBlock();
initCardCarousel();
initCheck();
toggleBlockVisibility();
initPlfeForm();
initTeledeclarationTab();